import { render, staticRenderFns } from "./switchPageTwoDialog.vue?vue&type=template&id=92be8b46&"
import script from "./switchPageTwoDialog.vue?vue&type=script&lang=js&"
export * from "./switchPageTwoDialog.vue?vue&type=script&lang=js&"
import style0 from "./switchPageTwoDialog.vue?vue&type=style&index=0&id=92be8b46&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports